<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2><i class="bi bi-filter"></i><label for="select_year_month">{{"SELECTMONTH" | translate}}</label> </h2>
			<select 
			class="form-select" 
			aria-label="Month selection"
			(change)="fncCng($event)">
				<option *ngFor="let date of monthDropdown" [value]="date">
					{{ getMonthYear(date) }}
				</option>
			</select>
		</div>
		<div class="col-auto co_name">
			<h2>{{"CompanyName" | translate}}:</h2>
			<p>asdf</p>
		</div>
		<div class="summary col-auto gap-2">
			<button class="btn btn-primary btn-sm"><i class="bi bi-download"></i> Download</button>
			<!-- <button class="btn btn-primary btn-sm"><i class="bi bi-check2-all"></i> Approve All</button> -->
		</div>
		</section>
</div>
<!--  ############### Top Select Month End ################# -->
  <div class="container_wrapper">


	<!-- <div class="time_sheet_ligend" *ngIf="lang === 'en'">
		<ul>
			<li class="status"><span>{{"STATUS" | translate}}</span></li>
			<li class="nSubmit"><s>{{"Status.N" | translate}}</s><span>{{"Status.NOTSUBMIT" | translate}}</span></li>
			<li class="submit"><s>{{"Status.S" | translate}}</s><span>{{"Status.SUBMIT" | translate}}</span></li>
			<li class="fix"><s>F</s><span>Fix</span></li>
			<li class="reject"><s>{{"Status.R" | translate}}</s><span>{{"Status.APPROVE" | translate}}</span></li>
			<li class="approve"><s>{{"Status.A" | translate}}</s><span>{{"Status.REJECT" | translate}}</span></li>
		</ul>
	</div> -->
    <!--  ############### Data Table Start ################# -->
	<div class="client_associate_list">

        <p-table 
        #dt2
        [value]="associatesList" [tableStyle]="{'width':'100%'}" 
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['userName', 'contractTerm']"
        currentPageReportTemplate="{{'Showing' |translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}"
        (onFilter)="onFilter($event)"
        (onPage)="onPage($event)"
        (onSort)="onSort()">
        <!-- <table class="display nowrap table table-striped" style="width:100%"> -->
            <ng-template #caption>
                
                    <p-iconfield iconPosition="left" class="ml-auto">                        
                        <label>{{"SearchByText" | translate}}:</label>
                        <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="{{'SearchKey' | translate}}" />
                    </p-iconfield>
                
            </ng-template>
            <ng-template pTemplate="header">                
                <!-- <thead> -->
                    <tr class="tbl_head">
                        <th rowspan="2">{{"AssociatesList.Section" | translate}}</th>
                        <th rowspan="2">{{"AssociatesList.Name" | translate}}</th>
                        <th colspan="4">{{"AssociatesList.TWH" | translate}}</th>
                        <th colspan="4">{{"AssociatesList.STATUS" | translate}}</th>
                        <th colspan="3">{{"AssociatesList.Summary" | translate}}</th>
                        <th rowspan="2" class="min-desktop">{{"AssociatesList.ContractTerm" | translate}}</th>
                    </tr>
                    <tr class="tbl_head">
                        <th pSortableColumn="code" style="width:20%">
                            <div class="flex items-center gap-2">
                                {{"AssociatesList.REGULAR" | translate}}
                                <p-sortIcon field="code" />
                            </div>
                        </th>
                        <th>{{"AssociatesList.OVERTIME" | translate}}</th>
                        <th>{{"AssociatesList.MIDNIGHT" | translate}}</th>
                        <th>{{"AssociatesList.TOTAL" | translate}}</th>
                        <th>{{"AssociatesList.NOTSUBMIT" | translate}}</th>
                        <th>{{"AssociatesList.SUBMIT" | translate}}</th>
                        <th>{{"AssociatesList.REJECT" | translate}}</th>
                        <th>{{"AssociatesList.APPROVE" | translate}}</th>
                        <th>{{"AssociatesList.home" | translate}}</th>
                        <th>{{"AssociatesList.Absence" | translate}}</th>
                        <th>{{"AssociatesList.PaidHoliday" | translate}}</th>
                        <!-- <th>{{"AssociatesList.ContractTerm" | translate}}</th> -->
                    </tr>
                <!-- </thead>     -->
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr class="tbl_cont">
                <td><a href="#" class="dlt_link">{{item.section}}</a></td>
                    <td><a href="client-timesheet/{{item.timesheetID}}" class="dlt_link">{{item.userName}} </a></td>
                    <td>{{item.regular}}</td>
                    <td>{{item.overtime}}</td>
                    <td>{{item.midnightOvertime}}</td>
                    <td>{{item.total}}</td>
                    <td>{{item.notSubmit}}</td>
                    <td>{{item.submit}}</td>
                    <td>{{item.reject}}</td>
                    <td>{{item.approve}}</td>
                    <td>{{item.teleWork}}</td>
                    <td>{{item.absence}}</td>
                    <td>{{item.paidHoliday}}</td>
                    <td>{{item.contractTerm}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr class="tbl_fot">
                    <td colspan="2">{{"TOTAL" | translate}}</td>
                        <td>{{ totalRegular }}</td>  <!-- Regular total -->
						<td>{{ totalOverTime }}</td>  <!-- Overtime total -->
						<td>{{ totalMn }}</td>  <!-- Midnight total -->
						<td>{{ overAllTotal }}</td>  <!-- Overall total -->
						<td>{{ totalNotSubmit }}</td>  <!-- Not Submit -->
						<td>{{totalSubmit}}</td>  <!-- Submit -->
						<td>{{totalReject}}</td>  <!-- Reject -->
						<td>{{totalApprove}}</td>  <!-- Approve -->
						<td>{{totalHome}}</td>  <!-- Home -->
						<td>{{totalAbsence}}</td>  <!-- Absence -->
						<td>{{totalPh}}</td>  <!-- Paid Holiday -->
						<td>&nbsp;</td>
                </tr>
                </ng-template>
            <!-- <ng-template #paginatorleft>
                <p-button type="button" icon="pi pi-plus" text />
            </ng-template>
            <ng-template #paginatorright>
                <p-button type="button" icon="pi pi-cloud" text />
            </ng-template> -->
        <!-- </table> -->
        </p-table>